/** Apenas dígitos; não remove zeros à esquerda (CPF/CNPJ válidos podem começar por 0). */
export function digitsOnly(value: string | undefined | null): string {
  return String(value ?? '').replace(/\D/g, '');
}

function allSameDigit(s: string): boolean {
  return /^(\d)\1+$/.test(s);
}

function digitAt(s: string, i: number): number {
  const ch = s[i];
  return ch === undefined ? NaN : Number(ch);
}

/** CPF com 11 dígitos e dígitos verificadores válidos (algoritmo Receita Federal). */
export function isCpfValid(value: string | undefined | null): boolean {
  const cpf = digitsOnly(value);
  if (cpf.length !== 11 || allSameDigit(cpf)) return false;

  let sum = 0;
  for (let i = 0; i < 9; i++) sum += digitAt(cpf, i) * (10 - i);
  let rest = sum % 11;
  const dv1 = rest < 2 ? 0 : 11 - rest;
  if (dv1 !== digitAt(cpf, 9)) return false;

  sum = 0;
  for (let i = 0; i < 10; i++) sum += digitAt(cpf, i) * (11 - i);
  rest = sum % 11;
  const dv2 = rest < 2 ? 0 : 11 - rest;
  return dv2 === digitAt(cpf, 10);
}

const CNPJ_WEIGHTS_1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2] as const;
const CNPJ_WEIGHTS_2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2] as const;

/** CNPJ com 14 dígitos e dígitos verificadores válidos. */
export function isCnpjValid(value: string | undefined | null): boolean {
  const cnpj = digitsOnly(value);
  if (cnpj.length !== 14 || allSameDigit(cnpj)) return false;

  let sum = 0;
  for (let i = 0; i < 12; i++) sum += digitAt(cnpj, i) * CNPJ_WEIGHTS_1[i];
  let d = sum % 11;
  const dv1 = d < 2 ? 0 : 11 - d;
  if (dv1 !== digitAt(cnpj, 12)) return false;

  sum = 0;
  for (let i = 0; i < 13; i++) sum += digitAt(cnpj, i) * CNPJ_WEIGHTS_2[i];
  d = sum % 11;
  const dv2 = d < 2 ? 0 : 11 - d;
  return dv2 === digitAt(cnpj, 13);
}

/** Aceita string mascarada; exige exatamente 11 (CPF) ou 14 (CNPJ) dígitos com DVs válidos. */
export function isCpfOrCnpjValid(value: string | undefined | null): boolean {
  const d = digitsOnly(value);
  if (d.length === 11) return isCpfValid(d);
  if (d.length === 14) return isCnpjValid(d);
  return false;
}

export const MSG_DOCUMENTO_INVALIDO =
  'Informe um CPF ou CNPJ válido (11 dígitos para CPF ou 14 para CNPJ, com dígitos verificadores corretos).';
